import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Stepper Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Steps of stepper
     * 
     * @example
     * [
     *     {
     *          icon: '',
     *          title: '',
     *          subtitle: '',
     *     }
     * ]
     */
    @Prop({ type: Array, required: true }) steps!: Array<Record<string, undefined>>;

    /**
     * Just show number of step
     */
    @Prop({ type: Boolean }) numeral!: boolean;

    /**
     * Base language
     */
    @Prop({ type: String, default: 'fa' }) lang!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string

    /**
     * Next button text
     */
    @Prop({ type: String }) nextButtonText!: string;

    /**
     * Back button text
     */
    @Prop({ type: String }) backButtonText!: string;

    /**
     * Next button color
     */
    @Prop({ type: String, default: 'primary' }) nextButtonColor!: string;

    /**
     * Back button color
     */
    @Prop({ type: String, default: 'default' }) backButtonColor!: string;

    /**
     * Next button size
     */
    @Prop({ type: String, default: 'normal' }) nextButtonSize!: string;

    /**
     * Back button size
     */
    @Prop({ type: String, default: 'normal' }) backButtonSize!: string;
    
    /**
     * Finish button text
     */
    @Prop({ type: String }) finishButtonText!: string;

    /**
     * Before change validation
     */
    @Prop({ type: Boolean, default: true }) beforeChange!: boolean;

    /**
     * Set Pass Icon for passed steps
     */
    @Prop({ type: Boolean }) passIcon!: boolean;

    /**
     * Set one-line mode
     */
    @Prop({ type: Boolean }) oneLine!: boolean;

    /**
     * Set simple mode
     */
    @Prop({ type: Boolean }) simple!: boolean;

    /**
     * Set minimal mode
     */
    @Prop({ type: Boolean }) minimal!: boolean;

    /**
     * Set badge modes
     */
    @Prop({ type: Boolean }) withTag!: boolean;

    /**
     * Allow click on each steps
     */
    @Prop({ type: Boolean }) clickable!: boolean;

    /**
     * Set shingle show mode
     */
    @Prop({ type: Boolean }) singleShow!: boolean;

    /**
     * Set responsive mode
     */
    @Prop({ type: Boolean, default: false }) responsiveMode!: boolean;

    /**
     * Set arrow scroll mode
     */
    @Prop({ type: Boolean, default: false }) arrowScroll!: boolean;

    /**
     * Set square mode on steps
     */
    @Prop({ type: Boolean, default: false }) square!: boolean;

    /**
     * Hide footer button
     */
    @Prop({ type: Boolean }) noFooter!: boolean;
}

export default Props;
